<template>
  <div id="M0" class="mypage">
    <div class="wrapper">
      <kg-header />
      <div id="content">
        <kg-user />
        <div id="myplan">
          <!-- TODO 作成保留 -->
        </div>
        <div id="myphoto">
          <!-- TODO 作成保留 -->
        </div>
        <kg-history
          :upperLimit="dispHistoryCount"
          :purchaseList="history"
          @clickHistoryMoreEvent="clickHistoryMore()"/>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'

import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {KG_STORAGE_KEY, KG_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// kagull Module
import Header from '../components/mypage/MyPageHeader'
import UserInfo from '../components/mypage/UserInfo'
import PurchaseHistory from '../components/mypage/PurchaseHistory'

export default {
  components: {
    'kg-header': Header,
    'kg-user': UserInfo,
    'kg-history': PurchaseHistory,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      dispHistoryCount: 4,
      history: []
    }
  },
  methods: {
    getHistory: function () {
      let userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
      let payload = {
        params: {
          userId: userInfo.userId
        }
      }
      return axios.get(KG_URL.MYPAGE + '/get-history', payload)
    },
    getMyPlan: function () {
      // プラン関連機能は未定
      return null
    },
    getMyPhoto: function () {
      // フォト関連機能は未定
      return null
    },
    getData: function () {
      this.$refs.loadingModalRef.showModal(true)
      // 各データを取得してからローディングモーダルを非表示にするために同期制御をする
      axios.all([this.getMyPlan(), this.getMyPhoto(), this.getHistory()])
        .then(axios.spread((planResponse, photoResponse, hisResponse) => {
          // プラン
          if (planResponse != null && planResponse.data.errorMessage) {
            this.handleErrorMessage(planResponse)
          } else {
            // プラン設定処理
          }
          // フォト
          if (photoResponse != null && photoResponse.data.errorMessage) {
            this.handleErrorMessage(photoResponse)
          } else {
            // フォト設定処理
          }
          // 購入履歴
          if (hisResponse != null && hisResponse.data.errorMessage) {
            this.handleErrorMessage(hisResponse)
          } else {
            // 購入履歴設定処理
            this.history = []
            if (hisResponse.data.data) {
              hisResponse.data.data
                .forEach(e => {
                  let temp = {}
                  temp.userId = e.userId
                  temp.productName = e.productName
                  temp.orderNo = e.orderNo
                  temp.orderDate = e.orderDate
                  temp.totalPrice = e.totalPrice
                  this.history.push(temp)
                })
            }
          }
        })).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    clickHistoryMore: function () {
      this.dispHistoryCount += 4
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/MyPage.vue